function ControlSidebar() {
  return (
    <>
      <aside class="control-sidebar control-sidebar-dark"></aside>
    </>
  );
}

export default ControlSidebar;
